module.exports = __webpack_public_path__ + "media/images/icon_company_badge2-3b8bbba72d5a729226299a30fc1a0d6f.svg";